import {  Button, 
          Grid, 
          LinearProgress, 
          MobileStepper,
          TableCell,
          CircularProgress,
          Popover,
          Divider,
          ListItem,
          Typography,
          List,
        } from '@material-ui/core';
import { ApolloConsumer } from 'react-apollo';



import GridItem from 'components/Grid/GridItem.jsx';
import { calculateDrivingHours } from 'helpers/DrivingHoursConverter';
import { ParseUriParams } from 'helpers/UriReader';
import {
  GetUserId,
  GetUserKey,
  GetUserToken,
  Logout
} from 'helpers/UserHelper';
import moment from 'moment';
import { ClientQuoteInfoMedical } from 'queries/quotes/queries.js';
import { newQuoteMutationMedical } from 'queries/SubmitMedical';
import React, { Component } from 'react';
import { graphql, Query } from 'react-apollo';
import { Redirect } from 'react-router';
import { showSnack, successWarning } from 'reducers/NotificationReducer';
import { openProgress, addPendingTask } from 'reducers/TasksReducer';
import { reduxForm } from 'redux-form';
import store from 'store';
import BenefitDetails from './steps/BenefitDetails.jsx';
import BenefitSelection from './steps/BenefitSelection.jsx';
import CompanySelectionPageNew from './steps/CompanySelection.jsx';
import CompanySpecific from './steps/CompanySpecific.jsx';
import QuoteDetailsPage from './steps/QuoteDetails.jsx';


import BenefitMapping from './steps/BenefitMapping';
import { subFieldsPagesSyncErrors } from './objects/syncErrorHelper';
import {MedicalFsp, MedicalGapFsp, MedicalLoyaltyFsp} from './steps/MedicalFsp.jsx'
import gql from 'graphql-tag';
import {
	QuotePdfUri,
	ResultsPdfUri,
	ResultsPdfPhysicalPath
} from 'constants.js';
import { json2xml } from 'xml-js';
import { toNumber } from 'lodash';

const getResultPdf = gql`
	query result($path: String!, $content: String!) {
		ResultPdfMedical(path: $path, content: $content) {
			filename
		}
	}
`;

class QuoteWizardMedical extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 0,
      pageCount: 3,
      checkValidation: false,
      formInitiazed: false,
      benefitsInitialized: false,
      br: false,
      mat100: 0,
      mat75: 0,
      clientId: null,
      guid: null,
      selectedTargets: [],
      selectedTargetsGap: [],
      selectedTargetsLoyalty: [],
      selectedBenefits: [],
      selectedMiscBenefits: {},
      clientAge: null,
      income: 0,
      dependentsChild: [],
      dependentsAdult: [],
      dependentMedicalAmount: {},
      medicalAmount: 0,
      hospitalOnly : false,
      planType: "",
      coverLevel : "",
      hospitalLevel: "",
      chronicProvider: "",
      serviceProvider: "",
      gapCover: 0,
      gapLevel: 0,
      coPay: false,
      loyalty: false,
      brokerFee: 0,
      subsidy: 0,
      withoutMed: 0,
      startDate: "",
      hSaverOption: 0,
      dToD: 0,
      loadingPdf: false,
     

      resultsSet: false,
      popoverText: '',
      dialogTitle: '',
      dialogOpen: false,
      loadingPdf: false,
      downloadEl: null,
      anchorTop: 0,
      anchorLeft: 0,
      popoverOpen: false,


    };
  }

  componentDidMount() {
    const params = ParseUriParams(this.props.location.search);
    const { clientId, guid, page } = params;
    this.setState({ clientId: clientId, guid: guid });
    if(page)
    {
      this.setState({page: toNumber(page)})
      console.log("THIS IS PAAAAGE!!! " + page)
    }
  }

  initializeForm(data) {

    
    const defaultInit = {
      //Fields you can't see
      Admin: data.scd_pAdmin,
      Travel: data.scd_pTravel,
      ManualLabour: data.scd_pManual,
      Supervision: data.scd_pSupervision,
      spouseIncome: data.scd_spouseIncome,
      title: data.scd_title,
      name: data.scd_name,
      surname: data.scd_surname,
      dateOfBirth: data.scd_dateOfBirth,
      gender: data.scd_gender,
      smoker: data.scd_smoker,
      qualification: data.scd_qualification,
      occupation: data.scd_occupation,
      selfEmployed: data.scd_selfEmployed,
      income: data.scd_monthlyIncome,
      salaryType: data.scd_salaryType,
      maritalStatus: data.scd_maritalStatus,
      TaxDispensation: data.scd_taxDispensation,
      calculatedMonthlyIncomeAT: data.scd_calculatedMonthlyIncomeAT
        ? data.scd_calculatedMonthlyIncomeAT
        : '0',
      actualMonthlyIncomeAT: data.scd_actualMonthlyIncomeAT
        ? data.scd_actualMonthlyIncomeAT
        : '0',
      //Fields you can see
      comission: '100',
      percentageUpfronCommission: '100',
      PAAWCommission: '0',
      language: 'English',
      brokerFee: '0',
      subsidy: '0',
      url: ""

      

      
    };

    let editData = {};

    if (this.state.guid) {
      //Auto Populate targets
      let { selectedTargets } = this.state;
      let editTargets = data.targets.split(',').map(t => parseInt(t, 10));
      let availTargets = MedicalFsp.map(t =>
        parseInt(t.id, 10)
      );
      this.state.selectedTargets = data.targets.split(',')

      let { selectedTargetsLoyalty } = this.state;
      let editTargetsLoyalty = data.targets.split(',').map(t => parseInt(t, 10));
      let availTargetsLoyalty = MedicalLoyaltyFsp.map(t =>
        parseInt(t.id, 10)
      );

      editTargets.map(t => {
        if (availTargets.includes(t)) {
          selectedTargets.push(t);
        }
        return t;
      });

     //console.log("[][][][][][][][][][][]" + data.benefits)

      editTargetsLoyalty.map(t => {
        if (availTargets.includes(t)) {
          selectedTargets.push(t);
        }
        return t;
      });

			let miscBenefits = {};
			
      try {
        if (data.misc_benefits) miscBenefits = JSON.parse(data.misc_benefits);
      } catch (e) {}

      this.setState({
        selectedTargets: selectedTargets,
        selectedMiscBenefits: miscBenefits
      });

      editData = JSON.parse(data.formValues);

      var adults = [];
      var children = [];

      for( const element in editData)
      {
        if(element.includes("childDepDateOfBirth"))
        {
          var n = this.state.dependentsChild;
          var child = n.length
          if(n[n.length-1])
            child = n[n.length-1].id +1
          n.push({
                  id: child,
                  dob: editData[element]
                })
          this.setState({dependentsChild : n});

          
        }

        if(element.includes("adultDepDateOfBirth"))
        {
          var n = this.state.dependentsAdult;
          var adult = n.length
          var wm = 0;
          if(editData["yearsWithoutM" + adult])
            wm = editData["yearsWithoutM" + adult];
          if(n[n.length-1])
            adult = n[n.length-1].id +1
          n.push({
                  id: adult,
                  dob: editData[element],
                  withoutMed: wm,
                  prevMeds: []
                })
          
          this.setState({dependentsAdult : n});
        }
      }
     var targetsGap = [];
     targetsGap.push(data.benefits)
    
     //This.setState for some reason does not set the state. Expicitly setting state values. Need to find out what is happening. Perhaps need to redo the medicaWizard initialization.
     this.setState({
      hospitalLevel: editData.hospitalType,
      serviceProvider: editData.serviceType,
      chronicProvider: editData.chronicType,
      coverLevel: editData.coverType,
      subsidy: editData.subsidy,
      selectedTargets: data.targets.split(","),
      gapCover: editData.gapCover,
      loyalty: editData.loyalty,
      gapLevel: editData.gapCoverLevel,
      coPay: editData.paymentCover,
      hSaverOption: editData.hSaver,
      dToD: editData.dayToDay,
      selectedBenefits: targetsGap,
      selectedTargetsGap : targetsGap,
      startDate:  editData.startDate, 
     



    });
    this.state.planType = editData.planType
    this.state.hospitalLevel= editData.hospitalType
    this.state.serviceProvider= editData.serviceType
    this.state.chronicProvider= editData.chronicType
    this.state.coverLevel= editData.coverType
    this.state.subsidy= editData.subsidy
    this.state.selectedTargets= data.targets.split(",")
    this.state.gapCover= editData.gapCover
    this.state.loyalty= editData.loyalty
    this.state.gapLevel= editData.gapCoverLevel
    this.state.coPay= editData.paymentCover
    this.state.hSaverOption= editData.hSaver
    this.state.dToD= editData.dayToDay
    this.state.selectedBenefits= targetsGap
    this.state.selectedTargetsGap = targetsGap
    this.state.startDate=  editData.startDate
     
      if (editData.occupation !== data.scd_occupation) {
        delete editData.occupation;
        delete editData.occupationalQs;
      }

      editData = this.deleteClientFields(editData);
    }

    this.props.initialize({
      ...editData,
      ...defaultInit
    });

    if (data.scd_calculatedMonthlyIncomeAT) {
      var calcAt = parseFloat(data.scd_calculatedMonthlyIncomeAT);
      if (data.scd_actualMonthlyIncomeAT) {
        var acAt = parseFloat(data.scd_actualMonthlyIncomeAT);
        var value = Math.max(calcAt, acAt);
        this.setState({ mat75: value * 0.75, mat100: value });
      } else {
        this.setState({ mat75: calcAt * 0.75, mat100: calcAt });
      }
    }

    var age = moment().diff(data.scd_dateOfBirth, 'years');

    this.setState({ formInitiazed: true, clientAge: age,  income: defaultInit.calculatedMonthlyIncomeAT});
  }

  deleteClientFields(editData) {
    delete editData.Admin;
    delete editData.Travel;
    delete editData.ManualLabour;
    delete editData.Supervision;
    delete editData.spouseIncome;
    delete editData.title;
    delete editData.name;
    delete editData.surname;
    delete editData.dateOfBirth;
    delete editData.gender;
    delete editData.smoker;
    delete editData.qualification;
    delete editData.occupation;
    delete editData.selfEmployed;
    delete editData.income;
    delete editData.salaryType;
    delete editData.maritalStatus;
    delete editData.TaxDispensation;
    delete editData.calculatedMonthlyIncomeAT;
    delete editData.actualMonthlyIncomeAT;
    delete editData.comission;
    delete editData.percentageUpfronCommission;
    delete editData.PAAWCommission;
    delete editData.language;
    delete editData.startDate;

    return editData;
  }

  checkSelectedTarget = (id, checked) => {
    let selectedTargets = [...this.state.selectedTargets];

    if (checked) {
      selectedTargets.push(id);
    } else {
      selectedTargets = selectedTargets.filter(t => t !== id);
    }

    this.setState({ selectedTargets: selectedTargets });
  };

  checkSelectedTargetGap = (id, checked) => 
  {
    let selectedTargets = [...this.state.selectedTargetsGap];

    if (checked) {
      selectedTargets.push(id);
    } else {
      selectedTargets = selectedTargets.filter(t => t !== id);
    }

    this.setState({ selectedTargetsGap: selectedTargets });
    this.setState({ selectedBenefits: selectedTargets });
    
  };

  checkSelectedTargetLoyalty = (id, checked) => {
    let selectedTargets = [...this.state.selectedTargetsLoyalty];

    if (checked) {
      selectedTargets.push(id);
    } else {
      selectedTargets = selectedTargets.filter(t => t !== id);
    }

    this.setState({ selectedTargetsLoyalty: selectedTargets });
  };

  toggleAllTargets = (targets, checked) => {
    let selectedTargets = [...this.state.selectedTargets];
    if (checked) {
      targets.map(t => {
        if (!selectedTargets.includes(t.id)) {
          selectedTargets.push(t.id);
        }
        return t;
      });
    } else {
      selectedTargets = [];
    }
    this.setState({ selectedTargets: selectedTargets });
  };

  toggleAllTargetsGap = (targets, checked) => {
    let selectedTargets = [...this.state.selectedTargetsGap];
    if (checked) {
      targets.map(t => {
        if (!selectedTargets.includes(t.id)) {
          selectedTargets.push(t.id);
        }
        return t;
      });
    } else {
      selectedTargets = [];
    }
    this.setState({ selectedTargetsGap: selectedTargets });
  };

  toggleAllTargetsLoyalty = (targets, checked) => {
    let selectedTargets = [...this.state.selectedTargetsLoyalty];
    if (checked) {
      targets.map(t => {
        if (!selectedTargets.includes(t.id)) {
          selectedTargets.push(t.id);
        }
        return t;
      });
    } else {
      selectedTargets = [];
    }
    this.setState({ selectedTargetsLoyalty: selectedTargets });
  };

  checkSelectedBenefit = (id, checked) => {
    let selectedBenefits = [...this.state.selectedBenefits];

    if (checked) {
      selectedBenefits.push(id);
    } else {
      selectedBenefits = selectedBenefits.filter(t => t !== id);
    }

    this.setState({ selectedBenefits: selectedBenefits });
  };

  checkSelectedMiscBenefit = (id, checked, targets = []) => {
    let selectedMiscBenefits = { ...this.state.selectedMiscBenefits };

    if (checked) {
      selectedMiscBenefits[`misc${id}`] = targets;
    } else {
      delete selectedMiscBenefits[`misc${id}`];
    }

    this.setState({ selectedMiscBenefits: selectedMiscBenefits });
    this.forceUpdate();
  };

  checkMiscBenefitTarget = (id, checked, targetId) => {
    let selectedMiscBenefits = { ...this.state.selectedMiscBenefits };
    if (!selectedMiscBenefits[`misc${id}`]) return;

    let selectedTargets = [...selectedMiscBenefits[`misc${id}`]];

    if (checked) {
      selectedTargets = [...selectedTargets, targetId];
    } else {
      selectedTargets = selectedTargets.filter(t => t !== targetId);
    }

    this.setState({
      selectedMiscBenefits: {
        ...selectedMiscBenefits,
        [`misc${id}`]: selectedTargets
      }
    });
    this.forceUpdate();
  };

  toggleAllBenefits = (benefits, checked) => {
    let selectedBenefits = [...this.state.selectedBenefits];
    if (checked) {
      benefits.map(b => {
        if (!selectedBenefits.includes(b.id)) {
          selectedBenefits.push(b.id);
        }
        return b;
      });
    } else {
      selectedBenefits = [];
    }

    this.setState({ selectedBenefits: selectedBenefits });
  };

  checkCommision() {
    let values = store.getState().form.quotev2.values;
    if (!values) return true;

    let total =
      parseInt(values['percentageUpfronCommission'], 10) +
      parseInt(values['PAAWCommission'], 10);
    if (total !== parseInt(values['comission'], 10)) {
      return false;
    }
    return true;
  }

  nextPage() {
    if (this.state.page === 0 || this.state.page === 20) {
      this.pushNextPage();
      this.forceUpdate();
      return;
    }

    let comErr = this.state.page === 1 && !this.checkCommision();

    let syncErrors = { ...store.getState().form.quotev2.syncErrors };
    syncErrors = syncErrors
      ? subFieldsPagesSyncErrors(syncErrors, this.state.page)
      : null;

    if ((syncErrors && Object.keys(syncErrors).length > 0) || comErr) {
      comErr
        ? this.showDangerSnack(
            `Upfront commission and As-and-when commission do not add up to total commission percentage`
          )
        : this.showDangerSnack('Invalid Information');
      this.setState({ checkValidation: true });
    } else {
      this.pushNextPage();
    }
    this.forceUpdate();
  }

  previousPage() {
    this.setState({ checkValidation: false, page: this.state.page - 1 });
  }

  pushNextPage = () => {
    this.setState({ page: this.state.page + 1 });
    this.setState({ checkValidation: false });
  };

  showDangerSnack(message) {
    store.dispatch(
      showSnack({
        message: message,
        color: 'danger'
      })
    );
  }

  checkAssistantActive() {
    return GetUserKey('userType') === '6' ? true : false;
  }

  getBrokerId = () => {
    let brokerId = GetUserId();
    if (this.checkAssistantActive()) {
      brokerId = sessionStorage.getItem('ActiveBrokerId');
    }
    return brokerId;
  };

  submit() {
    
   
    let syncErrors = { ...store.getState().form.quotev2.syncErrors };
    syncErrors = syncErrors
      ? subFieldsPagesSyncErrors(syncErrors, this.state.page)
      : null;

    if (syncErrors && Object.keys(syncErrors).length > 0) {
      this.setState({ checkValidation: true });
      store.dispatch(
        showSnack({
          message: 'Invalid Information',
          color: 'danger'
        })
      );
    } else {
      this.setState({ checkValidation: false });

      const fieldValuesRaw = { ...store.getState().form.quotev2.values };

      var pTravel = store.getState().form.quotev2.values.Travel;

      fieldValuesRaw.drivingHours = calculateDrivingHours(pTravel);

      fieldValuesRaw['medicalSecondOpinion'] = 'Y';

      const params = ParseUriParams(this.props.location.search);
      const { clientId } = params;

      const input = {
        token: GetUserToken(),
        userId: this.getBrokerId(),
        clientId: clientId,
        benefits: [...this.state.selectedBenefits],
        misc_benefits: { ...this.state.selectedMiscBenefits },
        assistantId: GetUserKey('userType') === '6' ? GetUserId() : null,
        targets: this.state.selectedTargets,
        data: fieldValuesRaw
      };

      this.props
        .mutate({
          variables: {
            input
          }
        })
        .then(resp => {
          store.dispatch(
            successWarning({
              open: true,
              title: 'Quote Submitted!'
            })
          );
          store.dispatch(openProgress());
          
          this.setState({guid : resp.data.newQuoteMedical.guid})
          this.setState({page: 3})
         
        })
        .catch(error => {
          store.dispatch(
            showSnack({
              message:
                'There was an error submitting your quote : ' +
                error,
              color: 'danger'
            })
          );
        });
    }
    return false;
  }

  handleAddDependentAdult = value =>
  {
      var n = this.state.dependentsAdult;
      var adult = n.length
      if(n[n.length-1])
        adult = n[n.length-1].id +1
      n.push({
              id: adult,
              dob:"01/01/0001",
              withoutMed: 0,
              prevMeds: []
            })
      
      this.setState({dependentsAdult : n});
  }

  handleRemoveDependentAdult = (e) =>
  {
    var i = e.currentTarget.id.replace("adultDepRemove", "")
    var n = this.state.dependentsAdult;
    var n2 = [];
    
   
    for(var k=0; k < n.length; k++)
    {
      if(i!= n[k].id)
      {
        n2.push(n[k])
      }
      else
      console.log("")
    }
    this.setState({dependentsAdult : n2});
  }

  handleChangeM(x,y)
  {
    //console.log(y)
      var z = ""
      z+= y[0];
      if(y[1])
        z += y[1]

      var n = this.state.medicalAmount;
      n = z;
      
      
      this.setState({medicalAmount: n})
  }

  handleChangeDM(e,y)
  {
   
    var i = "";
    var value = "";
    var endOfId = false;
    for(var k=0; k < 999; k++)
    {
      if(!e[k])
        break;
      if(e[k] == ":")
      {
        endOfId = true;
        k++;
      }
        
      
      if(!endOfId)
      {
        i += e[k];
      }
      else
      value += e[k]
      
    }
    //.log(i)
   // console.log(value)
    var n = this.state.dependentsAdult;
    
    if(value > n[i].prevMeds.length)
      for(var k=n[i].prevMeds.length; k < value; k++)
      {
        n[i].prevMeds.push(
        {
          name: "",
          startDate: "",
          endDate: ""
        })
      }
    else
    {
      for(var k=n[i].prevMeds.length; k > value; k--)
      {
        n[i].prevMeds.pop();
      }
    }
    
     this.setState({dependentMedicalAmount: n})
  }

  changechildDob = (e, i, dob) =>
  {

    i = e.target.id.replace("childDepDateOfBirth", "")
    var n = this.state.dependentsChild;
    n[i].dob = dob;
    this.setState({dependentsChild : n});
  }

  handleAddDependentChild = value =>
  {
      var n = this.state.dependentsChild;
      var child = n.length
      if(n[n.length-1])
        child = n[n.length-1].id +1
      n.push({
              id: child,
              dob:0
            })
     // console.log(child)
      this.setState({dependentsChild : n});
  }

  handleRemoveDependentChild = (e) =>
  {
      var i = e.currentTarget.id.replace("childDepRemove", "")
      var n = this.state.dependentsChild;
      var n2 = [];
      //console.log(i)
     
      for(var k=0; k < n.length; k++)
      {
        if(i!= n[k].id)
        {
          n2.push(n[k])
        }
        else
        console.log("")
      }
      this.setState({dependentsChild : n2});
  }

  changeGap = (n) =>
  {
    //console.log(n)
   
     this.setState({gapCover: n})
    

  }

  changeLoyalty = (n) =>
  {
    this.setState({loyalty: n})
  }

  changeHospitalOnly = (n) =>
  {
    this.setState({hospitalOnly: n})
  }

  changePlanType = (n) =>
  {
    
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({planType: value})
  }

  changeCoverLevel = (n) =>
  {
    
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({coverLevel: value})
  }

  changeHospitalLevel = (n) =>
  {
    
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({hospitalLevel: value})
  }

  changeChronicLevel = (n) =>
  {
    
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({chronicProvider: value})
  }

  changeServiceLevel = (n) =>
  {
    
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({serviceProvider: value})
  }

  changeDependentDob = (n) =>
  {
    
    var id = n.target.id.replace("adultDepDateOfBirth", "")
    var value = n.target.value;
    var dependents = this.state.dependentsAdult;
    dependents[id].dob = value;
    //console.log("This is SPARTA");
    //console.log(dependents);
    this.setState({dependentsAdult : dependents})
  }

  changeDependentDob = (n) =>
  {
    
    var id = n.target.id.replace("adultDepDateOfBirth", "")
    var value = n.target.value;
    var dependents = this.state.dependentsAdult;
    dependents[id].dob = value;
    //console.log("This is SPARTA");
    //console.log(dependents);
    this.setState({dependentsAdult : dependents})
  }

  changeDependentWithoutMed = (n) =>
  {
    
    var id = n.target.id.replace("yearsWithoutM", "")
    var value = n.target.value;
    var dependents = this.state.dependentsAdult;
    dependents[id].withoutMed = value;
    //console.log("This is SPARTA");
    //console.log(dependents);
    this.setState({dependentsAdult : dependents})
  }

  changeWithoutMed = (n) =>
  {
    var value = n.target.value;
    this.setState({withoutMed : value})
  }

  changeBrokerFee = (n) =>
  {
    //console.log(this.state)
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({brokerFee: value})
  }

  changeDToD = (n) =>
  {
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({dToD: value})
  }

  changeSubsidy = (n) =>
  {
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
     this.setState({subsidy: value})
  }
  
  
  changeStartDate = (n) =>
  {
    //console.log(n)
    var value = "";
    for(var k=0; k < Object.keys(n).length-1; k++)
      {
        value += n[k];
      }
      
     this.setState({startDate: value})
  }

  changeGapLevel = (n) =>
  {
    //console.log(n)
    var value = n[0];
    this.setState({gapLevel : value})
  }

  changeCoPay = (n) =>
  {
    var value = n[0];
    this.setState({coPay : value})
  }

  changeHSaverOption = (n) =>
  {
    var value = n[0];
    this.setState({hSaverOption : value})
  }

  handlePopoverClose = () => {
		this.setState({ popoverOpen: false });
	};

	handlePopoverOpen = event => {
		this.setState({
			anchorTop: event.clientY,
			anchorLeft: event.clientX,
			popoverOpen: true
		});
  };
  
  handleResultPdf = async (e, path, client) =>
  {
    this.setState({ loadingPdf: true });
		 const  { data, errors } = await client.query({
		query: getResultPdf,
		variables: {
		              path: path,
		              content: document
									.getElementById('resultTable')
									.innerHTML.toString()
                  .replace(/"/g, "'")
                }
              });
      var results = {data: data, errors: errors};
      return results;
  }

  onPdfGet = data => {
		var url = QuotePdfUri + this.state.pdfUrl + '.pdf';
		window.open(url, '_blank');
  };
  

  makeDownloadLinks() {
		var res = this.state.results;
		var col = [];
		col.push(
			<TableCell key={res} style={{ paddingRight: '0px' }}>
				<ApolloConsumer>
					{client => (
						<div>
							
							<Button
								id="printButton"
								variant="outlined"
								className="outlinedButton"
								style={{
									color: '#55526f',
									borderRadius: '50px',
									marginTop: '10px',
									marginBottom: '10px'
								}}
								onClick={e =>
									!this.state.loadingPdf
										? this.handlePopoverOpen(e, 'downloadEl')
										: {}
								}
							>
								{this.state.loadingPdf ? (
									<CircularProgress color="secondary" size={20} />
								) : (
									'Print version'
								)}
							</Button>
							<Popover
								open={this.state.popoverOpen}
								onClose={() => this.handlePopoverClose()}
								anchorReference="anchorPosition"
								anchorPosition={{
									left: this.state.anchorLeft,
									top: this.state.anchorTop
								}}
							>
								<List component="nav">
									<ListItem
										button
										onClick={async () => {
                      this.setState({ loadingPdf: true });
                      //var pdfUrls = " Medical_Quote " + new Date().toISOString().replace(".","").replace(/:/g, "_");
                      //console.log("+++++++++++++++++----------------------" + this.state.guid)
                      var pdfUrls = this.state.guid;
                      console.log(this.state.guid);
                      this.setState({pdfUrl: pdfUrls})
											const { data, errors } = await client.query({
												query: getResultPdf,
												variables: {
													path: pdfUrls,
													content: document
														.getElementById('resultTable')
														.outerHTML.toString()
														.replace(/"/g, "'")
												}
											});
											if (errors) {
												store.dispatch(
													showSnack({
														message: 'Error generating the PDF : ' + errors,
														color: 'danger'
													})
												);
											} else {
												this.onPdfGet(data);
											}
											this.setState({ loadingPdf: false });
											this.handlePopoverClose();
										}}
									>
										<Typography
											variant="subheading"
											style={{
												marginLeft: '10px',
												marginRight: '10px'
											}}
										>
											Print Version
										</Typography>
									</ListItem>

									<Divider />
								</List>
							</Popover>
						</div>
					)}
				</ApolloConsumer>
			</TableCell>
		);

		col.push(
			<TableCell key={'makeDownloadLinksBlank'} style={{ padding: '0px' }}>
				{' '}
			</TableCell>
		);

	

		return col;
	}

  render() {
    const { page } = this.state;
    const params = ParseUriParams(this.props.location.search);
    const { clientId, guid } = params;

    return (
      <Query
        query={ClientQuoteInfoMedical}
        variables={{
          brokerId: this.getBrokerId(),
          clientId: clientId,
          guid: guid,
          token: GetUserToken()
        }}
        fetchPolicy='network-only'
      >
        {({ loading, error, data }) => {
          if (loading)
            return (
              <div>
                <LinearProgress />
              </div>
            );
          if (
            error &&
            error.message &&
            error.message === 'GraphQL error: invalid token'
          ) {
            Logout();
            return <Redirect to='/app/portal/login' />;
          }

          if (error) return `Error! ${error.message}`;

          if (!this.state.formInitiazed) {
            this.initializeForm(data.ClientQuoteInfoMedical);
          }

          let clientFullname = `${data.ClientQuoteInfoMedical.scd_title} ${
            data.ClientQuoteInfoMedical.scd_name
          } ${data.ClientQuoteInfoMedical.scd_surname}`;
          //console.log(data.ClientQuoteInfoMedical.AvailTargetsForBroker)
          //Change the targets to Medical aid instead of insurance.
          //data.ClientQuoteInfoMedical.AvailTargetsForBroker = MedicalFsp
          //console.log(data.ClientQuoteInfoMedical.AvailTargetsForBroker)
          return (
            <React.Fragment>
              <Grid container>
                <GridItem xs={12} sm={12} md={12} style={{ margin: 'auto' }}>
                  <div className={'fixedStepper'}>
                    <Grid container>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={10}
                        style={{ margin: 'auto' }}
                      >
                        <div className={'stepperDiv'}>
                          <MobileStepper
                            type='progress'
                            steps={this.state.pageCount}
                            position='static'
                            activeStep={this.state.page}
                            nextButton={
                              <div style={{ display: 'flex' }}>
                                {this.state.page ===
                                this.state.pageCount - 1 ? (
                                  <Button
                                    variant='outlined'
                                    className='outlinedButton'
                                    color='secondary'
                                    style={{ marginRight: '10px' }}
                                    onClick={() => this.submit()}
                                  >
                                    Submit
                                  </Button>
                                ) : this.state.page < this.state.pageCount ?(
                                  <Button
                                    
                                    variant='outlined'
                                    className='outlinedButton'
                                    color='secondary'
                                    style={{ marginRight: '10px' }}
                                    onClick={() => this.nextPage()}
                                  >
                                    Next
                                  </Button>
                                ) : (<div/>)}
                              </div>
                            }
                            backButton={
                              <Button
                                variant='outlined'
                                className='outlinedButton'
                                color='secondary'
                                style={{ marginLeft: '10px' }}
                                onClick={() => this.previousPage()}
                                disabled={this.state.page === 0 ? true : false}
                              >
                                Back
                              </Button>
                            }
                          />
                        </div>
                      </GridItem>
                    </Grid>
                  </div>

                  <br />
                  {page === 0 && (
                    <QuoteDetailsPage
                    {...this.props}
                    targets={this.state.selectedTargets}
                    checkValidation={this.state.checkValidation}
                    clientFullname={clientFullname}
                    clientAge = {this.state.clientAge}
                    handleAddDependentChild = {this.handleAddDependentChild.bind(this)}
                    handleRemoveDependentChild = {this.handleRemoveDependentChild.bind(this)}
                    changechildDob = {this.changechildDob.bind(this)}
                    dependentsChild = {this.state.dependentsChild}
                    handleAddDependentAdult = {this.handleAddDependentAdult.bind(this)}
                    handleRemoveDependentAdult = {this.handleRemoveDependentAdult.bind(this)}
                    dependentsAdult = {this.state.dependentsAdult}
                    medicalAmount = {this.state.medicalAmount}
                    dependentMedicalAmount = {this.state.dependentMedicalAmount}
                    handleMedicalAmountChange = {this.handleChangeM.bind(this)}
                    handleMedicalAmountChangeD = {this.handleChangeDM.bind(this)}
                    changeDependentDob = {this.changeDependentDob.bind(this)}
                    changeDependentWithoutMed = {this.changeDependentWithoutMed.bind(this)}
                    changeWithoutMed = {this.changeWithoutMed.bind(this)}
                    changeStartDate = {this.changeStartDate.bind(this)}
                    changeHSaverOption = {this.changeHSaverOption.bind(this)}
                 

                  />
                  )}
                  {page === 1 && (
                     <BenefitSelection
                     {...this.props}
                     checkSelectedBenefit={this.checkSelectedBenefit}
                     selectedBenefits={this.state.selectedBenefits}
                     toggleAllBenefits={this.toggleAllBenefits}
                     changeGap = {this.changeGap.bind(this)}
                     changeLoyalty = {this.changeLoyalty.bind(this)}
                     changeHospitalOnly = {this.changeHospitalOnly.bind(this)}
                     changeCoverLevel = {this.changeCoverLevel.bind(this)}
                     changePlanType = {this.changePlanType.bind(this)}
                     changeHospitalLevel = {this.changeHospitalLevel.bind(this)}
                     changeChronicLevel = {this.changeChronicLevel.bind(this)}
                     changeServiceLevel = {this.changeServiceLevel.bind(this)}
                     changeBrokerFee = {this.changeBrokerFee.bind(this)}
                     changeSubsidy = {this.changeSubsidy.bind(this)}
                     changeGapLevel = {this.changeGapLevel.bind(this)}
                     changeCoPay = {this.changeCoPay.bind(this)}
                     changeDToD = {this.changeDToD.bind(this)}
                     loyalty = {this.state.loyalty}
                     gapCover = {this.state.gapCover}
                     hospitalOnly = {this.state.hospitalOnly}
                     clientAge={this.state.clientAge}
                     doesNotQualifyForIP={
                       data.ClientQuoteInfoMedical.doesNotQualifyForIP
                     }
                     clientFullname={clientFullname}
                     autoPopulatedBenefits={data.ClientQuoteInfoMedical.benefits}
                     benefitsInitialized={this.state.benefitsInitialized}
                     state = {this.state}
                     
                     
                   />

                   
                  )}
                  {page === 2 && (
                   

                    <div style={{ color: 'black' }}>
                    <CompanySelectionPageNew
                      {...this.props}
                      planType={this.state.planType}
                      coverLevel={this.state.coverLevel}
                      hospitalLevel={this.state.hospitalLevel}
                      chronicProvider={this.state.chronicProvider}
                      serviceProvider={this.state.serviceProvider}
                      checkSelectedTarget={this.checkSelectedTarget}
                      checkSelectedTargetGap={this.checkSelectedTargetGap}
                      checkSelectedTargetLoyalty={this.checkSelectedTargetLoyalty}
                      selectedTargets={this.state.selectedTargets}
                      selectedTargetsGap={this.state.selectedTargetsGap}
                      selectedTargetsLoyalty={this.state.selectedTargetsLoyalty}
                      toggleAllTargets={this.toggleAllTargets}
                      toggleAllTargetsGap={this.toggleAllTargetsGap}
                      toggleAllTargetsLoyalty={this.toggleAllTargetsLoyalty}
                      state = {this.state}
                     
                      gapCover = {this.state.gapCover}
                      loyalty = {this.state.loyalty}
                      state = {this.state}
                      AvailTargetsForBroker={
                        MedicalFsp
                      }
                      AvailTargetsForBrokerGap={
                        MedicalGapFsp
                      }
                      AvailTargetsForBrokerLoyalty={
                        MedicalLoyaltyFsp
                      }
                      clientFullname={clientFullname}
                      autoPopulatedCompanies={data.ClientQuoteInfoMedical.targets}
                    />
                  </div>
                  )}
                  {page === 3 && (
                    <BenefitMapping
                      {...this.props}
                      checkValidation={this.state.checkValidation}
                      selectedBenefits={this.state.selectedBenefits}
                      selectedTargets={this.state.selectedTargets}
                      clientFullname={clientFullname}
                      state={this.state}
                      handlePopoverClose ={this.handlePopoverClose.bind(this)}
                      handlePopoverOpen ={this.handlePopoverOpen.bind(this)}
                      handleResultPdf = {this.handleResultPdf.bind(this)}
                      onPdfGet = {this.onPdfGet.bind(this)}
                      makeDownloadLinks = {this.makeDownloadLinks()}
                    />
                  )}
                  
                </GridItem>
              </Grid>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

QuoteWizardMedical = reduxForm({
  form: 'quotev2',
  destroyOnUnmount: true
})(QuoteWizardMedical);

QuoteWizardMedical = graphql(newQuoteMutationMedical)(QuoteWizardMedical);

export default QuoteWizardMedical;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/QuoteWizardMedical.jsx